export default ({ word: _word, count, hideCount }) => {
  const word = count === 0 || count > 1 ? `${_word}s` : _word
  return hideCount ? word : `${count} ${word}`
}
